import { Box, Typography } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import SelectSoundEffectModal from "./SelectSoundEffectModal";
import { GetSoundEffectRequest } from "../../../../store/Apis/SuitesApps/VideoSuiteApi";
import { soundEffectVoiceData } from "../../../../Types/VideoSuite-Types";

interface AddSoundEffectButtonProps {
  showSoundEffectModal: boolean;
  soundEffectData?: soundEffectVoiceData[];
  setShowSoundEffectModal: (show: boolean) => void;
  setSoundEffectParams?: (data: GetSoundEffectRequest) => void;
  handleAddSoundEffectAction: (soundEffectId: string) => void;
  isLoading?: boolean;
}

export const AddSoundEffectButton = ({
  setShowSoundEffectModal,
  showSoundEffectModal,
  setSoundEffectParams,
  soundEffectData,
  handleAddSoundEffectAction,
  isLoading
}: AddSoundEffectButtonProps) => {
  return (
    <Box>
      <Box className="sound-effect-container">
        <Box
          onClick={() => setShowSoundEffectModal(true)}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            width: "fit-content",
          }}
        >
          <Box>
            <AddIcon
              sx={{
                color: "#12B6EA",
                margin: "4px",
                fontSize: "1.2rem",
              }}
            />
          </Box>
          <Typography
            sx={{
              fontFamily: "Roboto",
              fontWeight: "500",
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0.1px",
              color: "#12B6EA",
            }}
          >
            Add sound effect
          </Typography>
        </Box>
      </Box>
      {showSoundEffectModal && (
        <SelectSoundEffectModal
          setSoundEffectParams={setSoundEffectParams}
          open={showSoundEffectModal}
          voices={soundEffectData || []}
          addSoundEffectAction={handleAddSoundEffectAction}
          handleClose={() => setShowSoundEffectModal(false)}
          isLoading={isLoading}
        />
      )}
    </Box>
  );
};
